import { tailwindColors } from '@repo/tailwind-config/tailwind.vars'
import Badge, { BadgeProps } from '@repo/ui/badge'
import Typography from '@repo/ui/typography'

import { CseTypes } from '../../lib/types/models/cse/cse'
import InformationToolTip from './information-tooltip'

type Props = {
  cse?: Pick<CseTypes.CseBasic, 'identifier' | 'label'>
  size?: BadgeProps['size']
}

const CseIdentifierTooltip = ({ cse, size }: Props) => {
  if (!cse) return '-'

  return (
    <InformationToolTip icon={<Badge variant="blue" size={size} text={cse.identifier} />}>
      <Typography variant="label-medium" color={tailwindColors.white.DEFAULT}>
        {cse.label}
      </Typography>
    </InformationToolTip>
  )
}

export default CseIdentifierTooltip
